export default __webpack_public_path__ + "static/BigCommerce-d6a634793a098b93da6abd7c66d129dd.svg";